import * as React from "react";
const SvgSearch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.607 10.607a5 5 0 1 0-7.071-7.071 5 5 0 0 0 7.07 7.07Z"
    />
    <path stroke="#fff" strokeWidth={2} d="m10.253 10.253 4.95 4.95" />
  </svg>
);
export default SvgSearch;
